module.exports = __webpack_public_path__ + "static/img/picture_new@2x.77abe9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/picture_new@2x.png
// module id = oykn
// module chunks = 1